import { render } from "./CotizacionVacia.vue?vue&type=template&id=14fb0532&scoped=true"
import script from "./CotizacionVacia.vue?vue&type=script&lang=js"
export * from "./CotizacionVacia.vue?vue&type=script&lang=js"

import "./CotizacionVacia.vue?vue&type=style&index=0&id=14fb0532&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fb0532"]])

export default __exports__